import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useState } from 'react';
import { authApi } from '../utils/apiClient';

function VerifyPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const token = params.get('token');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleVerify = async () => {
    if (!token) {
      const message = 'Missing verification token.';
      setError(message);
      toast.error(message);
      return;
    }

    setLoading(true);
    setError('');
    const result = await authApi.verify(token);
    setLoading(false);

    if (!result.success) {
      setError(result.error);
      toast.error(result.error);
      return;
    }

    localStorage.setItem('verifyResponse', JSON.stringify(result.data));
    toast.success('Email verified – redirecting to dashboard');
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-emerald-50 to-white px-4 py-16">
      <div className="max-w-xl w-full bg-white border border-emerald-200 rounded-3xl p-10 shadow-2xl text-center space-y-6">
        <p className="text-xs uppercase tracking-[0.6em] text-emerald-500">Carewinners Admin</p>
        <h1 className="text-3xl font-semibold text-slate-900">Verify your email</h1>
        <p className="text-slate-600">
          A verification link has been shared to your email — click it to complete the verification step, then return here to sign in.
        </p>
        {token && (
          <p className="text-slate-400 text-sm">
            Token captured from the link: <span className="font-mono text-[0.8rem] text-slate-700 break-all">{token}</span>
          </p>
        )}
        {error && (
          <p className="text-sm text-rose-600" aria-live="assertive">
            {error}
          </p>
        )}
        <div className="flex flex-col gap-3 items-center">
          <button
            type="button"
            onClick={handleVerify}
            disabled={loading}
            className="inline-flex w-full items-center justify-center rounded-2xl bg-[#78C45E] px-6 py-3 text-sm font-semibold text-white transition hover:bg-[#78C45E]/90 focus:outline-none focus:ring-2 focus:ring-emerald-400/70 disabled:opacity-60 disabled:cursor-wait"
          >
            {loading ? 'Verifying…' : 'Verify account'}
          </button>
          <Link
            to="/"
            className="text-sm text-emerald-500 underline decoration-emerald-400 hover:text-emerald-600"
          >
            Back to login
          </Link>
        </div>
      </div>
    </div>
  );
}

export default VerifyPage;
